module.exports = __webpack_public_path__ + "img/ZAdyn4Bplus-front.f5f2c923.jpg";